import { triggerBlobDownload } from '@/utils/download';
import { toSafeExportFileName } from '@/utils/file-name';
import type { ReportExportContext } from '../hooks/useReportExport';

export const exportReportToJson = ({
    report,
    fileNameSuffix,
}: ReportExportContext): boolean => {
    try {
        const payload = JSON.stringify(report, null, 2);
        const blob = new Blob([payload], { type: 'application/json' });
        triggerBlobDownload(
            blob,
            `${toSafeExportFileName(report.name, 'report')}${fileNameSuffix}.json`,
        );
        return true;
    } catch {
        return false;
    }
};
